import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { GlassCard } from '../components/GlassCard';
import { GlassInput } from '../components/GlassInput';
import { GlassButton } from '../components/GlassButton';
export function LoginPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const {
    login,
    register
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const success = isLogin ? await login(email, password) : await register(email, password);
    if (success) {
      navigate('/');
    } else {
      setError(isLogin ? 'Invalid credentials' : 'Email already exists');
    }
  };
  return <div className="min-h-screen flex items-center justify-center p-4" data-id="element-155">
      <GlassCard className="w-full max-w-md p-8" data-id="element-156">
        <div className="text-center mb-8" data-id="element-157">
          <h1 className="text-4xl font-bold text-white mb-2" data-id="element-158">Our Goals</h1>
          <p className="text-white/70" data-id="element-159">Track our financial journey together</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-160">
          <GlassInput type="email" label="Email" placeholder="you@example.com" value={email} onChange={setEmail} required data-id="element-161" />

          <GlassInput type="password" label="Password" placeholder="••••••••" value={password} onChange={setPassword} required data-id="element-162" />

          {error && <p className="text-red-300 text-sm text-center" data-id="element-163">{error}</p>}

          <GlassButton type="submit" variant="primary" className="w-full" data-id="element-164">
            {isLogin ? 'Sign In' : 'Create Account'}
          </GlassButton>
        </form>

        <div className="mt-6 text-center" data-id="element-165">
          <button onClick={() => {
          setIsLogin(!isLogin);
          setError('');
        }} className="text-white/70 hover:text-white transition-colors text-sm" data-id="element-166">
            {isLogin ? "Don't have an account? Sign up" : 'Already have an account? Sign in'}
          </button>
        </div>
      </GlassCard>
    </div>;
}